////////LIBRARY/////////
import ActionsTypes from '../../constants/ActionsTypes'

const initKioskManager = {
	resetDataBusiness: () => ({
		type: ActionsTypes.RESET_DATA_INIT_KIOSK_BUSINESS,
	}),
	getKiosksBusinessView: (
		filters = {},
		queryParams = { page: '0', size: '250', sort: 'reqKiosk.labelToManufacturer', nameDir: 'asc', sort_2: 'dateCreated', nameDir_2: 'asc' }
	) => ({
		type: ActionsTypes.GET_INIT_KIOSKS_BUSINESS,
		payload: {
			filters,
			queryParams,
		},
	}),
	getKiosksBusinessViewSuccess: (data) => ({
		type: ActionsTypes.GET_INIT_KIOSKS_BUSINESS_SUCCESS,
		payload: {
			data,
		},
	}),
	getKiosksBusinessViewFailure: (error) => ({
		type: ActionsTypes.GET_INIT_KIOSKS_BUSINESS_FAILURE,
		payload: {
			error,
		},
	}),
	resetDataCustomer: () => ({
		type: ActionsTypes.RESET_DATA_INIT_KIOSK_CUSTOMER,
	}),
	getKiosksCustomerView: (filters = {}, queryParams = { page: '0', size: '250', sort: 'idRequest', nameDir: 'asc' }) => ({
		type: ActionsTypes.GET_INIT_KIOSKS_CUSTOMER,
		payload: {
			filters,
			queryParams,
		},
	}),
	getKiosksCustomerViewSuccess: (data) => ({
		type: ActionsTypes.GET_INIT_KIOSKS_CUSTOMER_SUCCESS,
		payload: {
			data,
		},
	}),
	getKiosksCustomerViewFailure: (error) => ({
		type: ActionsTypes.GET_INIT_KIOSKS_CUSTOMER_FAILURE,
		payload: {
			error,
		},
	}),
	setRequestCustomerParams: (id, statusId, readOnly = false, step) => ({
		type: ActionsTypes.SET_REQUEST_CUSTOMER_PARAMS,
		payload: {
			id,
			statusId,
			readOnly,
			step,
		},
	}),
	setRequestBusinessParams: (id, statusId, readOnly = false, step) => ({
		type: ActionsTypes.SET_REQUEST_BUSINESS_PARAMS,
		payload: {
			id,
			statusId,
			readOnly,
			step,
		},
	}),
	putKioskBuild: (requestId, query) => ({
		type: ActionsTypes.PUT_KIOSK_BUILD,
		payload: {
			requestId,
			query,
		},
	}),
	putKioskBuildSuccess: () => ({
		type: ActionsTypes.PUT_KIOSK_BUILD_SUCCESS,
	}),
	putKioskBuildFailure: (error) => ({
		type: ActionsTypes.PUT_KIOSK_BUILD_FAILURE,
		payload: {
			error,
		},
	}),
	viewProductionSheet: (requestId) => ({
		type: ActionsTypes.VIEW_PRODUCTION_SHEET,
		payload: {
			requestId,
		},
	}),
	viewProductionSheetSuccess: (data) => ({
		type: ActionsTypes.VIEW_PRODUCTION_SHEET_SUCCESS,
		payload: {
			data,
		},
	}),
	viewProductionSheetFailure: (error) => ({
		type: ActionsTypes.VIEW_PRODUCTION_SHEET_FAILURE,
		payload: {
			error,
		},
	}),
}

export default initKioskManager
